import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
const CardTable = memo(function CardTable2({ items, isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarCard.TableSkeleton, {});
  }
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(CarCard.Table, { items, ...props });
});
export {
  CardTable
};
